import { gql } from '@apollo/client'

import { UserFragment } from './user.fragment'
import { FileFragment } from './file.fragment'

export const CommentFragment = gql`
  fragment CommentFragment on Comment {
    id
    createdDate
    updatedDate
    value
    file {
      ...FileFragment
    }
    url
    author {
      ...UserFragment
    }
  }
  ${FileFragment}
  ${UserFragment}
`
